import React from "react";
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { Menu, Layout, Modal } from "antd";
import { setCookie, getCookie, getUrlParam, DateFormat } from '@/common/utils/commonFunc'
import BottomSettings from "@/components/bottomSettings";
import WorkingStatusBar from "@/components/workingStatus";
import { getCSMemu, getUserSurveyDetail, getNewCSPermission ,getCountryPageJump , getCrossCSPermission} from '@/common/js/api'
import { menuIconName, newCsTicket } from '@/common/js/qiankunConfig';
import CommonStore from '@/stores/commonStore';
import IconFont from '@/common/utils/iconfont'
import './index.less'
import { trackClickEvent, traceCommonEvent } from '@/common/js/omega'
import { SET_WORKBENCH_VERSION , ENV_PATH} from '@/common/js/const';
const { Sider } = Layout;

interface NavMenuProps extends RouteComponentProps {
    CommonStore?: typeof CommonStore;
    collapsed: boolean;
    onCollapse: any;
}

@inject('CommonStore')
@observer
class Nav extends React.Component<NavMenuProps, any> {
    constructor(props: NavMenuProps) {
        super(props);
        this.state = {
            CSMemu: [],
            lang: getUrlParam('lang') || getCookie('lang') || "en-US",
            satisfactionModal: false,
            survey_url: '',
            submit_status: 1,
            screen_status: 0,
            CSVersion: false,
            activeMenuIdList: [],
        };
    }
    componentDidMount() {
        this.getCSmenu()
        // 获取满意度相关
        if (getCookie('submit_status') !== 1) {
            this.satisfactionClick()
        } else if (getCookie('submit_status')) {
            this.setState({
                submit_status: getCookie('submit_status')
            })
        }
        setCookie('lang', this.state.lang, 24)
        this.props.history.listen(() => {
            this.updateActiveMenu()
        });
        

        this.getCrossCSVersion(()=>{
            this.getCsVersion()
        })
    }

    getCrossCSVersion = (back: () => any)=>{
        if(localStorage.getItem('jumpCross')){
            back && back()
            return
        }
        /** TODO 异常需要处理？ */
        getCrossCSPermission().then((res) => {
            if (res.status === 0) {
                const newCrossCSPermission = res.data?.result?.canPass;
                const url = res.data?.result?.url;
                // 灰度跳转判断
                if(!newCrossCSPermission && url) {
                    // window.location.replace(window.location.href.replace("-cross", ""))
                    window.location.replace(url);
                    return
                }
                // 2.1版本默认跳转到我的工作台页面
                if(newCrossCSPermission && window.location.hash === '#/' && window.location.pathname === '/fe/ark_fe'){
                    window.location.replace(window.location.href.replace("#/", "#/ark/work-bench-list"))
                }
            }
            back && back()
        }).catch(err => {
            back && back()
        })
    }

    getCsVersion = () => {
        // 1.0工作台地址 (我的工作台 & 工单列表页)  跳转到 2.0工作台地址
        // if(document.domain.includes("sim")){
        //     return
        // }
        if(window.location.pathname.includes("/fe/ark_fe") && (window.location.hash.includes('#/ark/ticket-lists') || window.location.hash.includes('#/ark/work-bench-list') )){
            window.location.replace(window.location.href.replace("/fe/ark_fe", "/fe/ticket/ark_fe"))
        }

        // 
        if(window.location.pathname.includes("/fe/ticket/ark_fe") && window.location.hash.includes('#/knowledge/AgentDetail')){
            window.location.replace(window.location.href.replace("/fe/ticket/ark_fe", "/fe/ark_fe"))
        }
    }

    satisfactionClick = (type?: string) => {
        getUserSurveyDetail().then((res) => {
            if (res.status === 0) {
                if (res.data) {
                    setCookie('submit_status', res.data.submit_status + '', 24)
                    this.setState({
                        screen_status: res.data.screen_status, // 是否弹窗       
                        survey_url: res.data.survey_url, // 问卷链接
                        submit_status: res.data.submit_status // 是否回答过
                    })
                    if (res.data.screen_status === 1) {
                        this.setState({
                            satisfactionModal: true,
                        });
                    } else if (type === 'icon') {
                        this.openHref()
                    }
                }
            }
        })
    }

    openHref = () => {
        window.open(this.state.survey_url, '_blank')
    }

    getCSmenu = () => {
        getCSMemu({
            lang: this.state.lang.replace('-', '_'),
            system:'cs-cross'
        }).then(res => {
            if (res.status === 0) {
                this.setState({
                    CSMemu: res.data.menuTree,
                }, () => this.updateActiveMenu()
                )
                 /** 预期内，显示菜单 */
                traceCommonEvent('menu_success');
            } else {
                traceCommonEvent('menu_failed');
            }
        })
    }

    handleSatisfactionOk = () => {
        this.openHref()
        this.setState({
            satisfactionModal: false,
        });
    }
    handleSatisfactionCancel = () => {
        this.setState({
            satisfactionModal: false,
        });
    }

    updateActiveMenu = () => {
        const activeMenu: any = this.props.CommonStore?.setActiveMenuIdList(this.state.CSMemu)
        this.setState({
            activeMenuIdList: activeMenu.activeMenuIdList
        })
        document.title = activeMenu.name
    }

    addLangToUrlSearch = (url: string) => {
        const urlArray = url.split("#")
        urlArray[0] = ENV_PATH + urlArray[0] + "?lang=" + this.state.lang
        return urlArray.join("#")
    }

    // 菜单栏添加埋点
    menuAddOmega = (item: any) => {
        trackClickEvent('ibt_cs_menu_ck', {
            page_id: item.id,
            page_name: item.name,
            pid: item.pid,
            time: DateFormat(new Date()),
            "workbench_version" : SET_WORKBENCH_VERSION()
        })       
    }

    render() {
        const TEXTS = this.props.CommonStore!.curLocales || {}
        return (
            <div className='container'>
                <Sider id="NAV"
                    collapsible width={240} collapsedWidth={60}
                    collapsed={this.props.collapsed}
                    onCollapse={this.props.onCollapse}
                    trigger={this.props.collapsed ? <IconFont type={'icon-NavSwitch-new'} /> : <IconFont type={'icon-NavSwitch-new'} />}>
                    <div className={`logo ${this.props.collapsed ? 'collapsed' : ''}`}>
                        <span>Global CS System</span>
                    </div>
                    <Menu
                        className="nav-menu"
                        style={{ backgroundColor: '#314F7C' }}
                        mode="inline" theme="dark"
                        triggerSubMenuAction='hover'
                    >
                        {this.state.CSMemu.map((item: { id: number; name: string; title?: string; childMenus: any[]; url: string; newTab: number; icon: string }) => {
                            if (!item.childMenus.length) {
                                // 一级导航
                                return (
                                    <Menu.Item
                                        key={item.id}
                                        onClick={this.menuAddOmega.bind(null, item)}
                                        className={this.state.activeMenuIdList.includes(item.id) ? 'active' : ''}
                                        icon={<IconFont type={`icon-${item.icon}`} />}>
                                        {
                                            <a
                                                href={this.addLangToUrlSearch(item.url)}
                                                target={item.newTab ? "_blank" : "_self"}
                                            >
                                                <span className='menuitem'>{item.name}</span>
                                            </a>
                                        }
                                    </Menu.Item>
                                )
                            } else {
                                // 有多级导航
                                return (
                                    <Menu.SubMenu key={item.url} title={item.name}
                                        popupClassName='micro-nav-popup'
                                        className={this.state.activeMenuIdList.includes(item.id) ? 'active' : 'noactive'}
                                        icon={<IconFont className={(item.icon === 'outsourcing' && this.state.activeMenuIdList.includes(item.id))
                                        ? 'outsourcing-active' : item.icon === 'outsourcing' ?
                                        'outsourcing' : ''} type={`icon-${item.icon}`} />}>
                                        {<Menu.Item className='title' key={item.id + 'title'}>
                                            {item.name}
                                        </Menu.Item>}
                                        {
                                            item.childMenus.map((itm) => {
                                                if (!itm.childMenus.length) {
                                                    // 二级导航
                                                    let url = itm.url
                                                    if (this.state.CSVersion && newCsTicket.some((item) => {
                                                        return url.includes(item)
                                                    })) {
                                                        // 新版工单页
                                                        url = url.replace("/fe/", '/fe/ticket/')
                                                    }
                                                    return (<Menu.Item
                                                        key={itm.id}
                                                        onClick={this.menuAddOmega.bind(null, itm)}
                                                        className={this.state.activeMenuIdList.includes(itm.id) ? 'active-sub' : 'noactive'}
                                                    >
                                                        <a
                                                            href={this.addLangToUrlSearch(url)}
                                                            target={itm.newTab ? "_blank" : "_self"}
                                                        >
                                                            {itm.name}
                                                        </a>
                                                    </Menu.Item>)
                                                } else {
                                                    // 有三级导航
                                                    return (
                                                        <Menu.SubMenu
                                                            key={itm.id}
                                                            title={itm.name}
                                                            className={this.state.activeMenuIdList.includes(itm.id) ? 'active-sub' : 'noactive'}
                                                            popupOffset={[0, -11]}>
                                                            {
                                                                itm.childMenus.map((subItem: { url: string; name: string; id: number; newTab: number }) => {
                                                                    return (
                                                                        <Menu.Item
                                                                            className={this.state.activeMenuIdList.includes(subItem.id) ? 'active-menu-item' : ''}
                                                                            key={subItem.id}
                                                                            onClick={this.menuAddOmega.bind(null, subItem)}
                                                                        >
                                                                            <a
                                                                                href={this.addLangToUrlSearch(subItem.url)}
                                                                                target={subItem.newTab ? "_blank" : "_self"}
                                                                            >
                                                                                {subItem.name}
                                                                            </a>
                                                                        </Menu.Item>
                                                                    )
                                                                })
                                                            }
                                                        </Menu.SubMenu>
                                                    )
                                                }
                                            })
                                        }
                                    </Menu.SubMenu>
                                )
                            }
                        })}

                        {/* 调查问卷  */}
                        {this.state.submit_status !== 1 &&
                            <Menu.Item key='satisfaction'
                                className='satisfaction'
                                icon={<IconFont type={menuIconName["satisfaction"]} />}
                                onClick={() => { this.satisfactionClick('icon') }}>
                                <span className="menuitem new-satisfaction">{TEXTS.satisfaction_title}</span>
                            </Menu.Item>}
                    </Menu>
                    {/*  导航底部 用户设置 + 消息系统 */}
                    {<BottomSettings collapsed={this.props.collapsed} />}
                </Sider>
                {/* 右上角工作状态栏 */}
                {this.props.CommonStore!.isReady && <WorkingStatusBar CSVersion={this.state.CSVersion}/>}
                <Modal
                    title={TEXTS.satisfaction_title}
                    visible={this.state.satisfactionModal}
                    onOk={this.handleSatisfactionOk}
                    onCancel={this.handleSatisfactionCancel}
                    okText={TEXTS.continue}
                    cancelText={TEXTS.cancel}
                    width={700}
                    className='satisfaction-modal'
                >
                    <div className="img-wrap"></div>
                    <p>{TEXTS.satisfaction_content}
                        <a target="_blank" rel="noopener noreferrer" className="satisfaction_href" href={this.state.survey_url}>{this.state.survey_url}</a>
                    </p>
                </Modal>
            </div>
        )
    }
}
export default withRouter(Nav);